export const GET_CURRENT_NETWORK = "GET_CURRENT_NETWORK";
export const INIT_APP = "INIT_APP";
export const CREATE_FUND = "CREATE_FUND";